module.exports = __webpack_public_path__ + "img/icon-extra-house.7d2f890b.svg";